import { ProtectedRoute, SignIn } from 'pages';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';

import { useUser } from 'contexts/UserProvider';
import path from './Path';

import useRoutesByRole from 'hooks/useRoutesByRole';
import EmployeeRouteTracking from 'pages/Operate/EmployeeRouteTracking/EmployeeRouteTracking';
import { useMemo } from 'react';
import {
  ACCOUNTANT_ROLE,
  ADMIN_ROLE,
  CN_ROLE,
  HO_ROLE,
  NS_ROLE,
  QLD_ROLE,
  QTCN_ROLE,
  SALE_ROLE,
  STOREKEEPER_ROLE,
  TREASURER_ROLE,
  PC_ROLE,
  KTD_ROLE,
} from 'utils/constants/userRole';
import PaymentSummaryPage from 'pages/Accountant/PaymentSummary/PaymentSummaryPage';
import DetailPaymentSummaryPage from 'pages/Accountant/PaymentSummary/DetailPaymentSummary/DetailPaymentSummaryPage';
import HandoverPage from 'pages/Accountant/Handover/HandoverPage';

const Router = () => {
  const { user, isLoading } = useUser();
  const routesByRole = useRoutesByRole();
  const routesByRoleDTO = useMemo(() => {
    const roles = [
      ADMIN_ROLE,
      HO_ROLE,
      CN_ROLE,
      SALE_ROLE,
      QLD_ROLE,
      QTCN_ROLE,
      ACCOUNTANT_ROLE,
      STOREKEEPER_ROLE,
      TREASURER_ROLE,
      NS_ROLE,
      PC_ROLE,
      KTD_ROLE,
    ];
    const routesDTO = [];

    if (user?.role && roles.includes(user?.role))
      routesDTO.push(
        ...routesByRole
          .map((route) =>
            (route.children ?? []).map((item) => {
              const Element = item.element;

              return {
                path: item.path,
                element: <Element />,
              };
            }),
          )
          .flat(),
      );

    return routesDTO;
  }, [routesByRole, user?.role]);

  const routes = useMemo(
    () => [
      {
        path: `${path.ROOT}`,
        element: <ProtectedRoute />,
        children: [
          ...routesByRoleDTO,

          {
            path: `${path.ROUTE_TRACKING}`,
            element: <EmployeeRouteTracking />,
          },
          {
            path: `${path.HANDOVER}`,
            element: <HandoverPage />,
          },
          // {
          //   path: `${path.PAYMENT_SUMMARY}`,
          //   element: <PaymentSummaryPage />,
          // },
          // {
          //   path: `${path.PAYMENT_SUMMARY_DETAIL}`,
          //   element: <DetailPaymentSummaryPage />,
          // },
        ],
      },

      { path: `${path.SIGNIN}`, element: <SignIn /> },
      { path: `${path.ALL}`, element: <Navigate to={`${path.ROOT}`} /> },
    ],
    [routesByRoleDTO],
  );

  if (isLoading) return <div />;

  // const routeByRole = user?.role?.includes('admin') //full quyền
  //   ? [{ path: `${path.USER}`, element: <UserPage /> }]
  //   : user?.role?.includes('ho') //ho
  //     ? []
  //     : user?.role?.includes('cn') //cn
  //       ? []
  //       : user?.role?.includes('sale') //Sale
  //         ? []
  //         : [];

  const router = createBrowserRouter(routes);

  return <RouterProvider router={router} />;
};

export default Router;
